import React, { useEffect, useState, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from '../_helpers/withRouter';
import NavBar from '../_components/navbar';
import { Button, Container, Card, Row, Label, Col } from 'reactstrap';
import FormControl from '@mui/material/FormControl';
import './styles.css';
import Select from 'react-select';
import Chart from 'react-apexcharts';
import { useNavigate } from 'react-router-dom';
import { homeAction, fazendaAction, authActions } from '../_actions';
import { stringUtils } from '../_utils';
import { history } from '../_helpers';
import '././styles.css';
import Animais from '../../../ClientApp/src/imgs/animais.png'
import Farm from '../../../ClientApp/src/imgs/farm.png'
import Users from '../../../ClientApp/src/imgs/users.png'
import LogoMigplus from '../../../ClientApp/src/imgs/logo.png'

const Home = (props) => {

    const { match: { params } } = props;
    const [selectedAno, setSelectedAno] = useState('');
    const [selectedFazenda, setSelectedFazenda] = useState('');
    const [selectedEmpresa, setSelectedEmpresa] = useState('');
    const [nomeFazenda, setNomeFazenda] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isFirstLoad = useRef(true);

    useEffect(() => {
        let filterModel = {
            id_fazenda: selectedFazenda == 0 ? '' : selectedFazenda,
            id_empresa: selectedEmpresa == 0 ? '' : selectedEmpresa,
            periodo: ''
        };
        dispatch(homeAction.getHome(filterModel, true));

    }, []);

    /*useEffect(() => {
        let filterModel = {
            id_fazenda: selectedFazenda == 0 ? '' : selectedFazenda,
            id_empresa: selectedEmpresa == 0 ? '' : selectedEmpresa,
            periodo: selectedAno,
            site: true
        };  
        console.log('ENTROU NO USEEFFECT')
            dispatch(homeAction.getHome(filterModel, true));
    }, [selectedFazenda, selectedEmpresa, selectedAno]);*/

    useEffect(() => {
        if (isFirstLoad.current) {
            isFirstLoad.current = false;
            return;
        }

        const filterModel = {
            id_fazenda: selectedFazenda == 0 ? '' : selectedFazenda,
            id_empresa: selectedEmpresa == 0 ? '' : selectedEmpresa,
            periodo: selectedAno,
            site: true
        };

        dispatch(homeAction.getHome(filterModel, true));
    }, [selectedFazenda, selectedEmpresa, selectedAno]);

    useEffect(() => {
        setSelectedAno('Selecione...')
    }, []);

    function cleanSelection() {
        setNomeFazenda('');
        setSelectedFazenda('');
        setSelectedEmpresa('');
        setSelectedAno('Selecione...');
    }


    const handleSelectChange = prop => event => {
        if (prop == 'id_fazenda') {
            setSelectedFazenda(event.value);
            setNomeFazenda(event.label);
        }

        if (prop == 'id_empresa') {
            setSelectedEmpresa(event.value);
        }

        if (prop == 'ano') {
            //pega o valor do ano selecionado
            setSelectedAno(event.label)
        }

        var event2 = {
            type: 'select',
            target: {
                value: event.value
            }
        };

        dispatch(fazendaAction.onChangeProps(prop, event2));
    };

    function formatarPeriodoRange(periodo) {
        try {
            if (periodo && typeof periodo === 'string') {
                if (periodo.includes(" - ")) {
                    return periodo.split(" - ").map(d => {
                        const parts = d.split(/[-/]/);
                        if (parts.length === 3) {
                            const day = parts[parts.length - 1].length === 4 ? parts[2] : parts[0];
                            const year = parts[0].length === 4 ? parts[0] : parts[2];
                            const month = parts[1];
                            return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year.substring(2)}`;
                        }
                        return d;
                    }).join(" - ");
                } else {
                    const parts = periodo.split(/[-/]/);
                    if (parts.length === 3) {
                        const year = parseInt(parts[0]);
                        const month = parseInt(parts[1]) - 1;
                        const day = parseInt(parts[2]);
                        const endDate = new Date(year, month, day);
                        const startDate = new Date(year, month, day);
                        startDate.setDate(endDate.getDate() - 20);
                        const fmt = (d) => `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear().toString().substring(2)}`;
                        return `${fmt(startDate)} - ${fmt(endDate)}`;
                    }
                }
            }
        } catch (e) { console.error(e); }
        return periodo;
    }

    function renderReproducaoList(titulo, dataObj) {
        if (!temDados(dataObj)) return null;

        return (
            <Col className="col-xl-4 col-md-4 ml-0 mr-0 mb-4">
                <div className="col mr-1">
                    <div className="text-sm font-weight-bold mb-1 pt-2">{titulo}</div>
                </div>
                <div className="col mr-1">
                    <div className="text-sm font-weight-bold mb-1 pt-2">Média: {dataObj.media.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%</div>
                </div>
                <div className="mt-2" style={{ maxHeight: '200px', overflowY: 'auto', border: '1px solid #eee', padding: '10px', borderRadius: '5px' }}>
                    {dataObj.options.map((periodo, index) => {
                        const labelPeriodo = formatarPeriodoRange(periodo);
                        const valor = dataObj.series[0].data[index];
                        return (
                            <div key={index} className="d-flex justify-content-between border-bottom py-1">
                                <span style={{ fontSize: '13px' }}>{labelPeriodo}:</span>
                                <span style={{ fontSize: '13px', fontWeight: 'bold' }}>
                                    {(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%
                                </span>
                            </div>
                        );
                    })}
                </div>
            </Col>
        );
    }

    const renderOptionsAnos = () => {
        const currentYear = new Date().getFullYear();
        const anos = [];

        for (let i = 0; i <= 5; i++) {
            anos.push({ value: (currentYear - i).toString(), label: (currentYear - i).toString() });
        }

        anos.unshift({ value: '', label: 'SELECIONE...' })

        return anos;
    };

    const renderOptionsFazenda = () => {
        if (props.home && props.home.fazendas) {
            let listaFazendas = props.home.fazendas.map((p, i) => {
                return (
                    { value: p.id_fazenda, label: p.nome_fazenda }
                );
            });

            // Verifica se selectedFazenda está dentro da lista de fazendas
            const existeNaLista = props.home.fazendas.some(fazenda => fazenda.id_fazenda === selectedFazenda);

            if (!existeNaLista && selectedFazenda !== '') {
                setNomeFazenda('');
                setSelectedFazenda('');
            }

            return listaFazendas; // Retorna a lista para ser usada se necessário

        } else {
            if (selectedFazenda !== '') {
                setNomeFazenda('');
                setSelectedFazenda('');
            }
        }
    };

    const temDados = (grafico) => {
        if (!grafico || !grafico.series || !Array.isArray(grafico.series) || grafico.series.length === 0) return false;

        if (typeof grafico.series[0] === 'number') {
            return grafico.series.some(v => v !== 0 && v !== null);
        }

        if (typeof grafico.series[0] === 'object') {
            return grafico.series.some(s => s.data && Array.isArray(s.data) && s.data.length > 0 && s.data.some(v => {
                if (v === null || v === undefined) return false;
                if (typeof v === 'object') return v.y !== 0 && v.y !== null;
                return v !== 0;
            }));
        }

        return true;
    };

    const renderOptionsEmpresa = () => {
        if (props.home && props.home.empresas) {
            return props.home.empresas.map((e, i) => {
                return (
                    { value: e.id, label: e.nome }
                );
            });
        }
    };

    return (
        <div className="root">
            <div>
                <NavBar {...props} />
                <br />
                {(authActions.isGestor() || authActions.isAdministrador()) &&
                    <>
                        <Row className="mt-1 ml-80 mr-2 mb-2" style={{ marginLeft: 80, justifyContent: 'start' }}>
                            {selectedFazenda == '' || selectedFazenda == 0 ?
                                <Label htmlFor="id_fazenda">Dados de todas as fazendas vinculadas ao seu usuário</Label>
                                : nomeFazenda != '' && selectedFazenda != 0 &&
                                <div style={{
                                    display: 'flex', flexDirection: 'row', placeItems: 'center'
                                }}>
                                    <Label htmlFor="id_fazenda">Dados da fazenda: &nbsp;<b>{nomeFazenda}</b></Label>
                                    {(selectedAno != '' && selectedAno != 0 && selectedAno != 'Selecione...' && nomeFazenda != '' && selectedFazenda != 0) &&
                                        <div style={{
                                            display: 'flex', flexDirection: 'row', placeItems: 'center'
                                        }}>
                                            <Label htmlFor="id_fazenda">&nbsp;referentes ao período de: &nbsp;<b>{selectedAno}</b></Label>
                                        </div>
                                    }
                                    {(selectedAno != 'Selecione...' || selectedFazenda != '') &&
                                        <>
                                            <Button className="ml-2 mb-2" size="sm" variant="contained" color="secondary" onClick={() => cleanSelection()}>Limpar</Button>
                                            <Button className="ml-2 mb-2" size="sm" variant="contained" color="info" onClick={() => window.print()}>Imprimir</Button>
                                        </>
                                    }
                                </div>
                            }
                        </Row>
                    </>
                }
                {
                    authActions.isInseminador() && props.authentication.user && props.authentication.user.id_empresa == 5 &&
                    <Container align="center" className="ml-10">
                        <div className="col-auto">
                            <img src={LogoMigplus} alt="migplus" width="200" style={{ padding: 15 }} />
                        </div>
                    </Container>
                }
                {
                    (authActions.isGestor() || authActions.isAdministrador()) &&
                    <Row className="mt-1 mr-2 mb-2" style={{ marginLeft: 65, justifyContent: 'start' }}>
                        <Col className="col-xl-3 col-md-3 ml-10">
                            <FormControl fullWidth >
                                <Label htmlFor="id_empresa" align="left">Empresa:</Label>
                                <Select
                                    classNamePrefix="select"
                                    value={renderOptionsEmpresa()?.filter(function (option) {
                                        return option.value === (selectedEmpresa || '');
                                    })}
                                    onChange={handleSelectChange('id_empresa')}
                                    isSearchable
                                    id="id_empresa"
                                    name="id_empresa"
                                    placeholder="Selecione..."
                                    options={renderOptionsEmpresa()}
                                />
                            </FormControl>
                        </Col>
                        <Col className="col-xl-3 col-md-3 ml-10">
                            <FormControl fullWidth >
                                <Label htmlFor="id_fazenda" align="left">Fazenda:</Label>
                                <Select
                                    classNamePrefix="select"
                                    value={renderOptionsFazenda()?.filter(function (option) {
                                        return option.value === (selectedFazenda || '');
                                    })}
                                    onChange={handleSelectChange('id_fazenda')}
                                    isSearchable
                                    id="id_fazenda"
                                    name="id_fazenda"
                                    placeholder="Selecione..."
                                    options={renderOptionsFazenda()}
                                />
                            </FormControl>
                        </Col>
                        <Col className="col-xl-3 col-md-3 ml-20">
                            <FormControl fullWidth >
                                <Label htmlFor="ano" align="left">Período:</Label>
                                <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    value={renderOptionsAnos()?.filter(function (option) {
                                        return option.value == (selectedAno || '');
                                    })}
                                    onChange={handleSelectChange('ano')}
                                    isSearchable
                                    placeholder="Selecione..."
                                    id="ano"
                                    name="ano"
                                    options={renderOptionsAnos()}
                                />
                            </FormControl>
                        </Col>
                    </Row>
                }
                {
                    (authActions.isGestor() || authActions.isAdministrador()) &&
                    <div style={{ justifyContent: 'center' }}>
                        <Row className="mt-4 mr-2 mb-2 ml-2">
                            <Col className="col-xl-12 col-md-12 ml-1 mr-0">
                                <Card style={{ display: 'flex', flexDirection: 'row' }}>
                                    <Col className="col-xl-4 col-md-4 ml-1 mr-0">
                                        <div className="card-body" onClick={() => navigate("/fazendas")} href="#">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col mr-1">
                                                    <div className="text-sm font-weight-bold mb-1">Total de Fazendas</div>
                                                    <div className="h4 mb-0 font-weight-bold text-gray-800">{props.home.total_fazendas ? stringUtils.formataValor(props.home.total_fazendas) : 0}</div>
                                                </div>
                                                <div className="col-auto">
                                                    <img src={Farm} alt="fazendas" width="110" style={{ padding: 15 }} />
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col className="col-xl-4 col-md-4 ml-0 mr-0" style={{ backgroundColor: 'transparent' }}>
                                            <div className="card-body" onClick={() => navigate("/animais")} href="#">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col mr-1">
                                                    <div className="text-sm font-weight-bold mb-1">Total de Animais</div>
                                                    <div className="h5 mb-0 font-weight-bold text-gray-800">{props.home.total_animais ? stringUtils.formataValor(props.home.total_animais) : 0}</div>
                                                </div>
                                                <div className="col-auto">
                                                    <img src={Animais} alt="animais" width="110" style={{ padding: 15 }} />
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col className="col-xl-4 col-md-4 ml-0 mr-0" style={{ backgroundColor: 'transparent' }}>
                                            <div className="card-body" onClick={() => navigate("/usuarios")} href="#">
                                            <div className="row no-gutters align-items-center">
                                                <div className="col mr-1">
                                                    <div className="text-sm font-weight-bold mb-1">Total de Usuários</div>
                                                    <div className="h5 mb-0 font-weight-bold text-gray-800">{props.home.total_usuarios ? stringUtils.formataValor(props.home.total_usuarios) : 0}</div>
                                                </div>
                                                <div className="col-auto">
                                                    <img src={Users} alt="usuarios" width="110" style={{ padding: 15 }} />
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Card>
                            </Col>
                        </Row>
                        {(selectedFazenda != 0 || selectedEmpresa != 0) &&
                            <Row className="mt-1 mr-2 mb-2 ml-2 mb-10" align="center">
                                <Col className="col-xl-12 col-md-12">
                                    <Card>
                                        <Container>
                                            <Row>
                                                <div className="col mr-1">
                                                    <div className="text-sm font-weight-bold mb-1 pt-2">Indicadores do leite</div>
                                                </div>
                                            </Row>
                                        </Container>
                                        <Row className="col-xl-12 col-md-12 ml-1 mr-0" style={{ backgroundColor: 'transparent', display: 'flex', flexDirection: 'row' }}>
                                            {selectedAno != 0 && selectedAno != 'Selecione...' && selectedAno != '' && temDados(props.home.graficoGorduraLeiteProteina) &&
                                                <Col className="col-xl-4 col-md-4" align="center">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Relação gordura/proteína</div>
                                                    </div>
                                                    <div style={{ justifyContent: 'center' }}>
                                                        <Chart
                                                            options={props.home.graficoGorduraLeiteProteina.options}
                                                            series={props.home.graficoGorduraLeiteProteina.series}
                                                            type="bar"
                                                            height="430"
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                            {selectedAno != 0 && selectedAno != 'Selecione...' && selectedAno != '' && temDados(props.home.graficoTanques) &&
                                                <Col className="col-xl-4 col-md-4" align="center">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Faturamento mensal</div>
                                                    </div>
                                                    <div style={{ justifyContent: 'center' }}>
                                                        <Chart
                                                            options={props.home.graficoTanques.options}
                                                            series={props.home.graficoTanques.series}
                                                            type="bar"
                                                            height="430"
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                            {selectedAno != 0 && selectedAno != 'Selecione...' && selectedAno != '' && temDados(props.home.graficoIndicadoresTanques) &&
                                                <Col className="col-xl-4 col-md-4" align="center">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Gordura/Proteína/Ureia por período</div>
                                                    </div>
                                                    <div style={{ justifyContent: 'center' }}>
                                                        <Chart
                                                            options={props.home.graficoIndicadoresTanques.options}
                                                            series={props.home.graficoIndicadoresTanques.series}
                                                            type="bar"
                                                            height="430"
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        }
                        {selectedFazenda != 0 && selectedAno != 0 && selectedAno != 'Selecione...' && selectedAno != '' &&
                            <Row className="mt-1 mr-2 mb-2 ml-2 mb-10" align="center">
                                <Col className="col-xl-12 col-md-12">
                                    <Card>
                                        <Container>
                                            <Row>
                                                <div className="col mr-1">
                                                    <div className="text-sm font-weight-bold mb-1 pt-2">Indicadores de Criação</div>
                                                </div>
                                            </Row>
                                        </Container>
                                        <Row className="col-xl-12 col-md-12 ml-1 mr-0" style={{ backgroundColor: 'transparent', display: 'flex', flexDirection: 'row', alignItems: 'center', alignContent: 'center', justifyContent: 'center' }}>

                                            {temDados(props.home.graficoIdadePrimeiroParto) &&
                                                <Col className="col-xl-4 col-md-4" align="center">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Gráfico de Idade ao Primeiro Parto</div>
                                                    </div>
                                                    <div style={{ justifyContent: 'center' }}>
                                                        <Chart
                                                            options={props.home.graficoIdadePrimeiroParto.options}
                                                            series={props.home.graficoIdadePrimeiroParto.series}
                                                            type="bar"
                                                            height="430"
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                            {temDados(props.home.graficoGanhoPesoDesmame) &&
                                                <Col className="col-xl-4 col-md-4" align="center">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Média de Ganho de Peso ao Desmame</div>
                                                    </div>
                                                    <div style={{ justifyContent: 'center' }}>
                                                        <Chart
                                                            options={props.home.graficoGanhoPesoDesmame.options}
                                                            series={props.home.graficoGanhoPesoDesmame.series}
                                                            type="bar"
                                                            height="430"
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                            {temDados(props.home.graficoProducaoNumeroPartos) &&
                                                <Col className="col-xl-4 col-md-4" align="center">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Produção por Número de Partos</div>
                                                    </div>
                                                    <div style={{ justifyContent: 'center' }}>
                                                        <Chart
                                                            options={props.home.graficoProducaoNumeroPartos.options}
                                                            series={props.home.graficoProducaoNumeroPartos.series}
                                                            type="pie"
                                                            height="430"
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        }
                        {(selectedFazenda != 0 || selectedEmpresa != 0) &&
                            <Row className="mt-1 mr-2 mb-2 ml-2 mb-10" align="center">
                                <Col className="col-xl-12 col-md-12">
                                    <Card>
                                        <Container>
                                            <Row>
                                                <div className="col mr-1">
                                                    <div className="text-sm font-weight-bold mb-1 pt-2">Indicadores de Produção</div>
                                                </div>
                                            </Row>
                                        </Container>
                                        <Row className="col-xl-12 col-md-12 ml-1 mr-0" style={{ backgroundColor: 'transparent', display: 'flex', flexDirection: 'row' }}>
                                            {temDados(props.home.graficoDel) &&
                                                <Col className="col-xl-4 col-md-4" align="center">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Distribuição do DEL do Rebanho</div>
                                                    </div>
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">DEL Médio {Math.round(props.home.graficoDel.media)}</div>
                                                    </div>
                                                    <div style={{ justifyContent: 'center' }}>
                                                        <Chart
                                                            options={props.home.graficoDel.options}
                                                            series={props.home.graficoDel.series}
                                                            type="pie"
                                                            height="430"
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                            {selectedAno != 0 && selectedAno != 'Selecione...' && selectedAno != '' &&
                                                <>
                                                    {temDados(props.home.graficoProducaoPorLote) &&
                                                        <Col className="col-xl-4 col-md-4" align="center">
                                                            <div className="col mr-1">
                                                                <div className="text-sm font-weight-bold mb-1 pt-2">Gráfico de Produção por Lote</div>
                                                            </div>
                                                            <div style={{ justifyContent: 'center' }}>
                                                                <Chart
                                                                    options={props.home.graficoProducaoPorLote.options}
                                                                    series={props.home.graficoProducaoPorLote.series}
                                                                    type="pie"
                                                                    height="430"
                                                                />
                                                            </div>
                                                        </Col>
                                                    }
                                                    {temDados(props.home.graficoProducaoPorDel) &&
                                                        <Col className="col-xl-4 col-md-4" align="center">
                                                            <div className="col mr-1">
                                                                <div className="text-sm font-weight-bold mb-1 pt-2">Gráfico de Produção por DEL</div>
                                                            </div>
                                                            <div className="col mr-1">
                                                                <div className="text-sm font-weight-bold mb-1 pt-2">Produção Média: {Math.round(props.home.graficoProducaoPorDel.media)}</div>
                                                            </div>
                                                            <div style={{ justifyContent: 'center' }}>
                                                                <Chart
                                                                    options={props.home.graficoProducaoPorDel.options}
                                                                    series={props.home.graficoProducaoPorDel.series}
                                                                    type="pie"
                                                                    height="430"
                                                                />
                                                            </div>
                                                        </Col>
                                                    }
                                                    {temDados(props.home.graficoDelMedioDias) &&
                                                        <Container>
                                                            <Col className="col-xl-6 col-md-6 pt-4" align="center">
                                                                <div className="col mr-1">
                                                                    <div className="text-sm font-weight-bold mb-1 pt-2">DEL médio em dias</div>
                                                                </div>
                                                                <div className="col mr-1">
                                                                    <div className="text-sm font-weight-bold mb-1 pt-2">Média: {Math.round(props.home.graficoDelMedioDias.media)}</div>
                                                                </div>
                                                                <div style={{ justifyContent: 'center' }}>
                                                                    <Chart
                                                                        options={props.home.graficoDelMedioDias.options}
                                                                        series={props.home.graficoDelMedioDias.series}
                                                                        type="bar"
                                                                        height="430"
                                                                    />
                                                                </div>
                                                            </Col>
                                                        </Container>
                                                    }
                                                </>
                                            }
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        }
                        {selectedFazenda != 0 && selectedAno != 0 && selectedAno != 'Selecione...' && selectedAno != '' &&
                            <Row className="mt-1 mr-2 mb-2 ml-2 mb-10" align="center">
                                <Col className="col-xl-12 col-md-12">
                                    <Card>
                                        <Container>
                                            <Row>
                                                <div className="col mr-1">
                                                    <div className="text-sm font-weight-bold mb-1 pt-2">Indicadores de Reprodução</div>
                                                </div>
                                            </Row>
                                        </Container>
                                         <Row className="col-xl-12 col-md-12 ml-1 mr-0" style={{ backgroundColor: 'transparent', display: 'flex', flexDirection: 'row' }}>
                                            {temDados(props.home.graficoTaxaConcepcaoVacas) &&
                                                <Col className="col-xl-4 col-md-4 ml-0 mr-0">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Taxa de Concepção Vacas</div>
                                                    </div>
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Média: {props.home.graficoTaxaConcepcaoVacas.media.toFixed(1)}%</div>
                                                    </div>
                                                    <Chart
                                                        options={props.home.graficoTaxaConcepcaoVacas.options}
                                                        series={props.home.graficoTaxaConcepcaoVacas.series}
                                                        type="bar"
                                                        height="470"
                                                    />
                                                </Col>
                                            }
                                            {renderReproducaoList("Taxa de Concepção 21 Dias Vacas", props.home.graficoTaxaConcepcao21DiasVacas)}
                                            {renderReproducaoList("Taxa de Inseminação 21 Dias Vacas", props.home.graficoTaxaInseminacao21DiasVacas)}
                                            {renderReproducaoList("Taxa de Prenhez 21 Dias Vacas", props.home.graficoTaxaPrenhez21DiasVacas)}

                                            {renderReproducaoList("Taxa de Concepção 21 Dias Novilhas", props.home.graficoTaxaConcepcao21DiasNovilhas)}
                                            {renderReproducaoList("Taxa de Inseminação 21 Dias Novilhas", props.home.graficoTaxaInseminacao21DiasNovilhas)}
                                            {renderReproducaoList("Taxa de Prenhez 21 Dias Novilhas", props.home.graficoTaxaPrenhez21DiasNovilhas)}

                                            {temDados(props.home.graficoTaxaConcepcaoTouros) &&
                                                <Col className="col-xl-4 col-md-4 ml-0 mr-0">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Taxa de Concepção Touros</div>
                                                    </div>
                                                    <div style={{ justifyContent: 'center' }}>
                                                        <Chart
                                                            options={props.home.graficoTaxaConcepcaoTouros.options}
                                                            series={props.home.graficoTaxaConcepcaoTouros.series}
                                                            type="bar"
                                                            height="470"
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                            {temDados(props.home.graficoTaxaConcepcaoInseminadores) &&
                                                <Col className="col-xl-4 col-md-4 ml-0 mr-0">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Taxa de Concepção Inseminadores</div>
                                                    </div>
                                                    <div style={{ justifyContent: 'center' }}>
                                                        <Chart
                                                            options={props.home.graficoTaxaConcepcaoInseminadores.options}
                                                            series={props.home.graficoTaxaConcepcaoInseminadores.series}
                                                            type="bar"
                                                            height="470"
                                                        />
                                                    </div>
                                                </Col>
                                            }
                                            {temDados(props.home.graficoIntervaloPartoAtePrimeiraInseminacao) &&
                                                <Col className="col-xl-4 col-md-4 ml-0 mr-0" style={{ backgroundColor: 'transparent' }}>
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Intervalo do Parto até a 1ª Inseminação</div>
                                                    </div>
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Média: {Math.round(props.home.graficoIntervaloPartoAtePrimeiraInseminacao.media)} (dias)</div>
                                                    </div>
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Ideal é ter intervalo menor que 60 dias.</div>
                                                    </div>
                                                    <Chart
                                                        options={props.home.graficoIntervaloPartoAtePrimeiraInseminacao.options}
                                                        series={props.home.graficoIntervaloPartoAtePrimeiraInseminacao.series}
                                                        type="bar"
                                                        height="440"
                                                    />
                                                </Col>
                                            }
                                            {temDados(props.home.graficoIntervaloPartos) &&
                                                <Col className="col-xl-4 col-md-4 ml-0 mr-0" style={{ backgroundColor: 'transparent' }}>
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Intervalos Entre Partos</div>
                                                    </div>
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Taxa de Concepção Média: {props.home.graficoIntervaloPartos.media.toFixed(1)}</div>
                                                    </div>
                                                    <Chart
                                                        options={props.home.graficoIntervaloPartos.options}
                                                        series={props.home.graficoIntervaloPartos.series}
                                                        type="bar"
                                                        height="440"
                                                    />
                                                </Col>
                                            }
                                            {temDados(props.home.graficoIntervaloPartoConcepcao) &&
                                                <Container>
                                                    <Col className="col-xl-6 col-md-6 pt-2" align="center">
                                                        <div className="col mr-1">
                                                            <div className="text-sm font-weight-bold mb-1 pt-2">Intervalo Parto Concepção</div>
                                                        </div>
                                                        <div style={{ justifyContent: 'center' }}>
                                                            <Chart
                                                                options={props.home.graficoIntervaloPartoConcepcao.options}
                                                                series={props.home.graficoIntervaloPartoConcepcao.series}
                                                                type="bar"
                                                                height="440"
                                                            />
                                                        </div>
                                                    </Col>
                                                </Container>
                                            }
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        }
                        {(selectedFazenda != 0 || selectedEmpresa != 0) &&
                            <Row className="mt-1 mr-2 mb-2 ml-2 mb-10" align="center">
                                <Col className="col-xl-12 col-md-12" align="center">
                                    <Card>
                                        <Container>
                                            <Row>
                                                <div className="col mr-1">
                                                    <div className="text-sm font-weight-bold mb-1 pt-2">Indicadores de Rebanho</div>
                                                </div>
                                            </Row>
                                        </Container>
                                        <Row className="col-xl-12 col-md-12 ml-1 mr-0" style={{ backgroundColor: 'transparent', display: 'flex', flexDirection: 'row' }}>
                                            {temDados(props.home.graficoAnimaisGrupos) &&
                                                <Col className="col-xl-4 col-md-4 ml-0 mr-0">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Quantidade de Animais por Grupo</div>
                                                    </div>
                                                    <Chart
                                                        options={props.home.graficoAnimaisGrupos.options}
                                                        series={props.home.graficoAnimaisGrupos.series}
                                                        type="pie"
                                                        height="430"
                                                    />
                                                </Col>
                                            }
                                            {selectedAno != 0 && selectedAno != 'Selecione...' && selectedAno != '' && temDados(props.home.graficoDistribuicaoPartos) &&
                                                <Col className="col-xl-4 col-md-4 ml-0 mr-0">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Distribuição do Número de Partos</div>
                                                    </div>
                                                    <Chart
                                                        options={props.home.graficoDistribuicaoPartos.options}
                                                        series={props.home.graficoDistribuicaoPartos.series}
                                                        type="pie"
                                                        height="430"
                                                    />
                                                </Col>
                                            }
                                            {selectedAno != 0 && selectedAno != 'Selecione...' && selectedAno != '' && temDados(props.home.graficoAnimaisAtivosPorPeriodo) &&
                                                <Col className="col-xl-4 col-md-4 ml-0 mr-0">
                                                    <div className="col mr-1">
                                                        <div className="text-sm font-weight-bold mb-1 pt-2">Animais ativos por período</div>
                                                    </div>
                                                    <Chart
                                                        options={props.home.graficoAnimaisAtivosPorPeriodo.options}
                                                        series={props.home.graficoAnimaisAtivosPorPeriodo.series}
                                                        type="bar"
                                                        height="430"
                                                    />
                                                </Col>
                                            }
                                        </Row>
                                    </Card>
                                </Col>
                            </Row>
                        }
                    </div>
                }
            </div >
        </div >
    );
}

function mapStateToProps(state) {
    return state;
}
const connectedHomePage = withRouter(connect(mapStateToProps, null, null, {
    pure: false
})(Home));

export { connectedHomePage as Home };